export default "__VITE_ASSET__80eaba25__"